import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { NumberInput } from '@iterable/deprecated_react_components';

export const ValueBoxContainer = styled.div`
  display: flex;
`;

export const StyledCoreNumberInput = styled(NumberInput)`
  &&&& {
    flex: 1 1 auto;
    margin: 0;
  }
`;

export const ColorPickerContainer = styled.div`
  align-items: center;
  display: flex;
  gap: ${pxToRem(5)};
  margin: 0 0 0 ${pxToRem(15)};
  width: ${pxToRem(120)};
`;

export const MinMaxLabel = styled.div`
  color: #616161;
  font-weight: 600;
  margin-left: ${pxToRem(10)};
`;
